import ReactMarkdown from "react-markdown";

import { useWMSProperty } from "hooks/propertyHooks";
import { useAttrtibute } from "hooks/indicatorHooks";

import { LayerProperties } from "types";

interface Props {
  config: string;
  layerId: number | "";
  attributeKey: string;
  value: string;
  query: string;
  layerProperties: LayerProperties[];
}

export function LayerSearchResultItemAttribute(props: Props) {
  const { config, layerId, attributeKey, query, layerProperties } = props;
  const values = useWMSProperty(props.value);

  const { data: attribute } = useAttrtibute(
    config,
    layerId,
    attributeKey,
    layerProperties
  );

  return (
    <>
      {attribute && (
        <div className="attribute-item">
          <label className="attribute-label">{attribute.label}:</label>
          <div className="attribute-value">
            <ReactMarkdown>
              {values.reduce(
                (combined, currentValue) =>
                  `${combined}\n${currentValue.replace(
                    new RegExp(`(${query})`, "gi"),
                    "**_$1_**"
                  )}`,
                ""
              )}
            </ReactMarkdown>
          </div>
        </div>
      )}
    </>
  );
}
